(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-hero"] && !Shopify.designMode) return;
  try {
    
  class NoorHero extends HTMLElement {
    connectedCallback() {
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('is-visible'));
      });

      if (this.dataset.parallax === 'true' && !this.reduced) this.#initParallax();
    }

    disconnectedCallback() {
      this.active = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.io) this.io.disconnect();
    }

    /* rAF loop rather than window scroll events — the theme may scroll an
       inner container, in which case scroll never reaches window. */
    #initParallax() {
      const tick = () => {
        if (!this.active) { this.raf = null; return; }
        this.#update();
        this.raf = requestAnimationFrame(tick);
      };

      const play = () => { if (!this.raf) this.raf = requestAnimationFrame(tick); };

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.active = entries[0].isIntersecting;
          if (this.active) play();
        }, { rootMargin: '200px 0px 200px 0px' });
        this.io.observe(this);
      } else {
        this.active = true;
        play();
      }

      this.#update();
    }

    #update() {
      const r = this.getBoundingClientRect();
      const p = Math.min(Math.max(-r.top / Math.max(r.height, 1), 0), 1);
      if (p === this._p) return;
      this._p = p;
      this.style.setProperty('--nd-p', p.toFixed(4));
    }
  }

  if (!customElements.get('noor-hero')) customElements.define('noor-hero', NoorHero);

  } catch(e) { console.error(e); }
})();
})();
